import { UserNotificationRouting } from '@/types/notificationConfig';
import { BaseNotification, NotificationCategory } from '@/types/notifications';

export class UserRoutingService {
  private routingConfig: UserNotificationRouting[] = [];
  
  constructor() {
    // Load routing configuration, for now we'll use a static example
    this.loadRoutingConfig();
  }
  
  private loadRoutingConfig(): void {
    // In a real implementation, this would load from a database or API
    // For now, we'll use a static example
    this.routingConfig = [
      {
        userId: 'admin-1',
        role: 'admin',
        notificationTypes: ['attendance', 'document', 'payment', 'system'],
        channels: {
          email: true,
          push: true,
          sms: true
        },
        contactInfo: {
          email: 'admin@example.com',
          phone: '+15551234567'
        }
      },
      {
        userId: 'teacher-1',
        role: 'teacher',
        notificationTypes: ['attendance', 'document'],
        channels: {
          email: true,
          push: true,
          sms: false
        },
        contactInfo: {
          email: 'teacher@example.com'
        }
      }
    ];
  }
  
  // Get recipients for a notification based on type and content
  public getRecipients(
    notification: BaseNotification, 
    specificUserId?: string
  ): UserNotificationRouting[] {
    // If a specific user is provided, only route to that user
    if (specificUserId) {
      return this.routingConfig.filter(config => config.userId === specificUserId);
    }
    
    // Otherwise, route based on notification type
    return this.routingConfig.filter(config => 
      config.notificationTypes.includes(notification.category)
    );
  }
  
  // Get contact info for a user
  public getContactInfo(userId: string): { email?: string, phone?: string } {
    const userConfig = this.routingConfig.find(config => config.userId === userId);
    return userConfig?.contactInfo || {};
  }
  
  // Add a new routing configuration
  public addRoutingConfig(config: UserNotificationRouting): void {
    // Remove any existing config for this user
    this.routingConfig = this.routingConfig.filter(c => c.userId !== config.userId);
    // Add the new config
    this.routingConfig.push(config);
    
    // In a real implementation, we would save this to storage
  }
  
  // Remove a routing configuration
  public removeRoutingConfig(userId: string): void {
    this.routingConfig = this.routingConfig.filter(c => c.userId !== userId);
    
    // In a real implementation, we would save this to storage
  }
  
  // Reset to default routing
  public resetRouting(): void {
    this.loadRoutingConfig();
  }
}
